import classNames from 'classnames';

import { setupForDark } from '@theme';

function PlaceholderHeader({ text, className }: { text: string; className?: string }) {
  return (
    <div
      className={classNames(
        'text-center',
        'sm:pl-xl sm:pr-xl',
        'H4 sm:H2',
        setupForDark('text-primary'),
        className
      )}
    >
      {text}
    </div>
  );
}

export default PlaceholderHeader;
